document.addEventListener('click',function(e){
  const link=e.target.closest('.mobile-nav__panel a');
  if(link){
    const details=link.closest('details');
    if(details) details.removeAttribute('open');
  }
});

/* NOCTA popup: once per browser visit/session. */
(function(){
  function initNoctaPopup(){
    var popup=document.getElementById('NoctaPromoPopup');
    if(!popup || popup.dataset.popupEnabled !== 'true') return;

    var showOnce=popup.dataset.showOnce === 'true';
    var key='nocta_promo_seen_v1';

    if(showOnce){
      try{
        if(sessionStorage.getItem(key)==='1') return;
      }catch(e){}
    }

    var open=function(){
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('nocta-popup-open');
      if(showOnce){
        try{ sessionStorage.setItem(key,'1'); }catch(e){}
      }
    };

    var close=function(){
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('nocta-popup-open');
    };

    popup.querySelectorAll('[data-popup-close]').forEach(function(el){
      el.addEventListener('click',close);
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && popup.classList.contains('is-visible')) close();
    });

    window.setTimeout(open,650);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initNoctaPopup);
  }else{
    initNoctaPopup();
  }
})();
